import React, { useState } from "react";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { courseSchema } from "../../../schema/courseSchema";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import {
  add_course,
  update_course,
  academy_course_categories,
} from "../../../data/ApiEndpoints";
import { useGetFetchNew } from "../../../data/Queries";
import useCloudFrontUpload from "../../../hooks/useCloudFrontUpload";
import { Form } from "react-bootstrap";

const UpdateCourse = ({
  initialValues,
  isEdit,
  closeModal,
  token,
  getCourseData,
}) => {
  const dispatch = useDispatch();
  const { uploadToCloudfront, isUploading } = useCloudFrontUpload();
  const [courseContent, setCourseContent] = useState(
    initialValues?.course_content || [{ content_title: "", sub_content: [""] }]
  );

  // Fetch categories
  const { data: categoriesData, isLoading: categoriesLoading } = useGetFetchNew(
    {
      token,
      key: "academy_course_categories",
      url: academy_course_categories,
    }
  );

  console.log("Initial values", initialValues);

  const formik = useFormik({
    initialValues: initialValues || {
      title: "",
      duration: "",
      accompany_people: "",
      batch_type: "",
      languages: "",
      price: "",
      about_course: "",
      course_content: [{ content_title: "", sub_content: [""] }],
      age: "",
      eligibility: "",
      weekend_start_time: "",
      weekend_end_time: "",
      weekday_start_time: "",
      weekday_end_time: "",
      thumbnail: "",
      banner: "",
      mobile_banner: "",
      category: "",
      status: "active",
    },
    validationSchema: courseSchema,
    onSubmit: async (values) => {
      const method = isEdit ? "PUT" : "POST";
      const endpoint = isEdit ? update_course : add_course;

      const payload = {
        ...values,
        course_content: courseContent,
        uid: initialValues?.uid,
      };

      console.log("API payload:", payload);

      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      console.log("API response:", result);

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        closeModal();
        getCourseData();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    },
  });

  const handleSubmitClick = () => {
    // console.log("Current form state:", {
    //   values: formik.values,
    //   errors: formik.errors,
    //   touched: formik.touched,
    //   isValid: formik.isValid,
    //   dirty: formik.dirty,
    //   courseContent: courseContent,
    // });
    formik.handleSubmit();
  };

  const handleContentChange = (index, field, value) => {
    const newContent = [...courseContent];
    if (field === "content_title") {
      newContent[index].content_title = value;
    } else {
      newContent[index].sub_content[field] = value;
    }
    setCourseContent(newContent);
    // Update Formik values
    formik.setFieldValue("course_content", newContent);
  };

  const addContentSection = () => {
    const newContent = [
      ...courseContent,
      { content_title: "", sub_content: [""] },
    ];
    setCourseContent(newContent);
    // Update Formik values
    formik.setFieldValue("course_content", newContent);
  };

  const addSubContent = (index) => {
    const newContent = [...courseContent];
    newContent[index].sub_content.push("");
    setCourseContent(newContent);
    // Update Formik values
    formik.setFieldValue("course_content", newContent);
  };

  const removeSubContent = (contentIndex, subIndex) => {
    const newContent = [...courseContent];
    newContent[contentIndex].sub_content = newContent[
      contentIndex
    ].sub_content.filter((_, index) => index !== subIndex);
    setCourseContent(newContent);
    formik.setFieldValue("course_content", newContent);
  };

  const removeContentSection = (index) => {
    const newContent = courseContent.filter((_, i) => i !== index);
    setCourseContent(newContent);
    formik.setFieldValue("course_content", newContent);
  };

  const handleImageUpload = async (e, fieldName) => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = await uploadToCloudfront(file, token);
      if (imageUrl) {
        formik.setFieldValue(fieldName, imageUrl);
      } else {
        toast.error(`Failed to upload ${fieldName} image`);
      }
    }
  };

  return (
    <div className="createNewCTOModalContainer mod-width-70p">
      <CommonHeadingNBtns
        title={isEdit ? "Edit Course" : "Add Course"}
        onClick={handleSubmitClick}
        isLoading={formik.isSubmitting || isUploading}
        btnTxt={isEdit ? "Update" : "Save"}
        onClose={closeModal}
      />

      <form
        className="management-form-container"
        onSubmit={formik.handleSubmit}
      >
        <div className="form-grid form-grid-2">
          <div className="management-form-group">
            <label className="management-form-label">
              Course Title <span className="required-indicator">*</span>
            </label>
            <input
              type="text"
              name="title"
              value={formik.values.title}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="Enter course title"
              className={`management-form-input ${
                formik.touched.title && formik.errors.title ? "error" : ""
              }`}
            />
            {formik.touched.title && formik.errors.title && (
              <div className="management-form-error">{formik.errors.title}</div>
            )}
          </div>

          <div className="management-form-group">
            <label className="management-form-label">
              Duration (in days) <span className="required-indicator">*</span>
            </label>
            <input
              type="text"
              name="duration"
              value={formik.values.duration}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="Enter duration"
              className={`management-form-input ${
                formik.touched.duration && formik.errors.duration ? "error" : ""
              }`}
            />
            {formik.touched.duration && formik.errors.duration && (
              <div className="management-form-error">
                {formik.errors.duration}
              </div>
            )}
          </div>

          <div className="management-form-group">
            <label className="management-form-label">
              Number of People <span className="required-indicator">*</span>
            </label>
            <input
              type="text"
              name="accompany_people"
              value={formik.values.accompany_people}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="Enter number of people"
              className={`management-form-input ${
                formik.touched.accompany_people &&
                formik.errors.accompany_people
                  ? "error"
                  : ""
              }`}
            />
            {formik.touched.accompany_people &&
              formik.errors.accompany_people && (
                <div className="management-form-error">
                  {formik.errors.accompany_people}
                </div>
              )}
          </div>

          <div className="management-form-group">
            <label className="management-form-label">
              Batch Type <span className="required-indicator">*</span>
            </label>
            <input
              type="text"
              name="batch_type"
              value={formik.values.batch_type}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="Enter batch type"
              className={`management-form-input ${
                formik.touched.batch_type && formik.errors.batch_type
                  ? "error"
                  : ""
              }`}
            />
            {formik.touched.batch_type && formik.errors.batch_type && (
              <div className="management-form-error">
                {formik.errors.batch_type}
              </div>
            )}
          </div>

          <div className="management-form-group">
            <label className="management-form-label">
              Languages <span className="required-indicator">*</span>
            </label>
            <input
              type="text"
              name="languages"
              value={formik.values.languages}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="Enter languages (comma separated)"
              className={`management-form-input ${
                formik.touched.languages && formik.errors.languages
                  ? "error"
                  : ""
              }`}
            />
            {formik.touched.languages && formik.errors.languages && (
              <div className="management-form-error">
                {formik.errors.languages}
              </div>
            )}
          </div>

          <div className="management-form-group">
            <label className="management-form-label">
              Price <span className="required-indicator">*</span>
            </label>
            <input
              type="text"
              name="price"
              value={formik.values.price}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="Enter price"
              className={`management-form-input ${
                formik.touched.price && formik.errors.price ? "error" : ""
              }`}
            />
            {formik.touched.price && formik.errors.price && (
              <div className="management-form-error">{formik.errors.price}</div>
            )}
          </div>

          <div className="management-form-group span2">
            <label className="management-form-label">
              About Course <span className="required-indicator">*</span>
            </label>
            <textarea
              name="about_course"
              value={formik.values.about_course}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="Enter course description"
              rows="4"
              className={`management-form-textarea ${
                formik.touched.about_course && formik.errors.about_course
                  ? "error"
                  : ""
              }`}
            />
            {formik.touched.about_course && formik.errors.about_course && (
              <div className="management-form-error">
                {formik.errors.about_course}
              </div>
            )}
          </div>

          <div className="management-form-group span2">
            <label className="management-form-label">
              Course Content <span className="required-indicator">*</span>
            </label>
            {courseContent.map((content, index) => (
              <div key={index} className="content-section">
                <div className="management-form-elements">
                  <input
                    type="text"
                    value={content.content_title}
                    onChange={(e) =>
                      handleContentChange(
                        index,
                        "content_title",
                        e.target.value
                      )
                    }
                    placeholder="Content title"
                    className={`management-form-input ${
                      formik.touched.course_content?.[index]?.content_title &&
                      formik.errors.course_content?.[index]?.content_title
                        ? "error"
                        : ""
                    }`}
                  />
                </div>
                {formik.touched.course_content?.[index]?.content_title &&
                  formik.errors.course_content?.[index]?.content_title && (
                    <div className="management-form-error">
                      {formik.errors.course_content[index].content_title}
                    </div>
                  )}
                {content.sub_content.map((sub, subIndex) => (
                  <div key={subIndex} className="management-form-elements">
                    <div className="" style={{ display: "flex", gap: "10px" }}>
                      <input
                        type="text"
                        value={sub}
                        onChange={(e) =>
                          handleContentChange(index, subIndex, e.target.value)
                        }
                        placeholder="Sub content"
                        className={`management-form-input ${
                          formik.touched.course_content?.[index]?.sub_content?.[
                            subIndex
                          ] &&
                          formik.errors.course_content?.[index]?.sub_content?.[
                            subIndex
                          ]
                            ? "error"
                            : ""
                        }`}
                      />
                      {content.sub_content.length > 1 && (
                        <button
                          type="button"
                          onClick={() => removeSubContent(index, subIndex)}
                          className="btn btn-danger btn-sm"
                          style={{ marginBottom: "10px" }}
                        >
                          Remove
                        </button>
                      )}
                    </div>
                  </div>
                ))}
                {formik.touched.course_content?.[index]?.sub_content &&
                  formik.errors.course_content?.[index]?.sub_content && (
                    <div className="management-form-error">
                      {formik.errors.course_content[index].sub_content}
                    </div>
                  )}
                <div
                  className=""
                  style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                  }}
                >
                  <button
                    type="button"
                    onClick={() => addSubContent(index)}
                    className="btn btn-danger btn-sm"
                  >
                    Add Sub Content
                  </button>
                  {courseContent.length > 1 && (
                    <button
                      type="button"
                      onClick={() => removeContentSection(index)}
                      className="btn btn-danger btn-sm"
                    >
                      Remove Section
                    </button>
                  )}
                </div>
              </div>
            ))}
            {formik.touched.course_content && formik.errors.course_content && (
              <div className="management-form-error">
                {typeof formik.errors.course_content === "string"
                  ? formik.errors.course_content
                  : "Course content is required"}
              </div>
            )}
            <button
              type="button"
              onClick={addContentSection}
              className="btn btn-danger btn-sm mt-3"
            >
              Add Content Section
            </button>
          </div>

          <div className="management-form-group">
            <label className="management-form-label">
              Age Requirement <span className="required-indicator">*</span>
            </label>
            <input
              type="text"
              name="age"
              value={formik.values.age}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="Enter age requirement"
              className={`management-form-input ${
                formik.touched.age && formik.errors.age ? "error" : ""
              }`}
            />
            {formik.touched.age && formik.errors.age && (
              <div className="management-form-error">{formik.errors.age}</div>
            )}
          </div>

          <div className="management-form-group">
            <label className="management-form-label">
              Eligibility <span className="required-indicator">*</span>
            </label>
            <input
              type="text"
              name="eligibility"
              value={formik.values.eligibility}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="Enter eligibility criteria"
              className={`management-form-input ${
                formik.touched.eligibility && formik.errors.eligibility
                  ? "error"
                  : ""
              }`}
            />
            {formik.touched.eligibility && formik.errors.eligibility && (
              <div className="management-form-error">
                {formik.errors.eligibility}
              </div>
            )}
          </div>

          <div className="management-form-group">
            <label className="management-form-label">
              Weekend Start Time <span className="required-indicator">*</span>
            </label>
            <input
              type="time"
              name="weekend_start_time"
              value={formik.values.weekend_start_time}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className={`management-form-input ${
                formik.touched.weekend_start_time &&
                formik.errors.weekend_start_time
                  ? "error"
                  : ""
              }`}
            />
            {formik.touched.weekend_start_time &&
              formik.errors.weekend_start_time && (
                <div className="management-form-error">
                  {formik.errors.weekend_start_time}
                </div>
              )}
          </div>

          <div className="management-form-group">
            <label className="management-form-label">
              Weekend End Time <span className="required-indicator">*</span>
            </label>
            <input
              type="time"
              name="weekend_end_time"
              value={formik.values.weekend_end_time}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className={`management-form-input ${
                formik.touched.weekend_end_time &&
                formik.errors.weekend_end_time
                  ? "error"
                  : ""
              }`}
            />
            {formik.touched.weekend_end_time &&
              formik.errors.weekend_end_time && (
                <div className="management-form-error">
                  {formik.errors.weekend_end_time}
                </div>
              )}
          </div>

          <div className="management-form-group">
            <label className="management-form-label">
              Weekday Start Time <span className="required-indicator">*</span>
            </label>
            <input
              type="time"
              name="weekday_start_time"
              value={formik.values.weekday_start_time}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className={`management-form-input ${
                formik.touched.weekday_start_time &&
                formik.errors.weekday_start_time
                  ? "error"
                  : ""
              }`}
            />
            {formik.touched.weekday_start_time &&
              formik.errors.weekday_start_time && (
                <div className="management-form-error">
                  {formik.errors.weekday_start_time}
                </div>
              )}
          </div>

          <div className="management-form-group">
            <label className="management-form-label">
              Weekday End Time <span className="required-indicator">*</span>
            </label>
            <input
              type="time"
              name="weekday_end_time"
              value={formik.values.weekday_end_time}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className={`management-form-input ${
                formik.touched.weekday_end_time &&
                formik.errors.weekday_end_time
                  ? "error"
                  : ""
              }`}
            />
            {formik.touched.weekday_end_time &&
              formik.errors.weekday_end_time && (
                <div className="management-form-error">
                  {formik.errors.weekday_end_time}
                </div>
              )}
          </div>

          <div className="management-form-group">
            <label className="management-form-label">
              Thumbnail <span className="required-indicator">*</span>
            </label>
            <div className="management-image-upload">
              {formik.values.thumbnail && (
                <div className="management-image-preview">
                  <img src={formik.values.thumbnail} alt="Thumbnail Preview" />
                </div>
              )}
              <div className="management-image-upload-inputs">
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => handleImageUpload(e, "thumbnail")}
                  className=""
                />
                <input
                  type="text"
                  name="thumbnail"
                  value={formik.values.thumbnail}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Or enter thumbnail URL"
                  className={`management-form-input ${
                    formik.touched.thumbnail && formik.errors.thumbnail
                      ? "error"
                      : ""
                  }`}
                />
              </div>
            </div>
            {formik.touched.thumbnail && formik.errors.thumbnail && (
              <div className="management-form-error">
                {formik.errors.thumbnail}
              </div>
            )}
          </div>

          <div className="management-form-group">
            <label className="management-form-label">
              Desktop Banner <span className="required-indicator">*</span>
            </label>
            <div className="management-image-upload">
              {formik.values.banner && (
                <div className="management-image-preview">
                  <img src={formik.values.banner} alt="Banner Preview" />
                </div>
              )}
              <div className="management-image-upload-inputs">
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => handleImageUpload(e, "banner")}
                  className=""
                />
                <input
                  type="text"
                  name="banner"
                  value={formik.values.banner}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Or enter banner URL"
                  className={`management-form-input ${
                    formik.touched.banner && formik.errors.banner ? "error" : ""
                  }`}
                />
              </div>
            </div>
            {formik.touched.banner && formik.errors.banner && (
              <div className="management-form-error">
                {formik.errors.banner}
              </div>
            )}
          </div>

          <div className="management-form-group">
            <label className="management-form-label">
              Mobile Banner <span className="required-indicator">*</span>
            </label>
            <div className="management-image-upload">
              {formik.values.mobile_banner && (
                <div className="management-image-preview">
                  <img
                    src={formik.values.mobile_banner}
                    alt="Mobile Banner Preview"
                  />
                </div>
              )}
              <div className="management-image-upload-inputs">
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => handleImageUpload(e, "mobile_banner")}
                  className=""
                />
                <input
                  type="text"
                  name="mobile_banner"
                  value={formik.values.mobile_banner}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Or enter mobile banner URL"
                  className={`management-form-input ${
                    formik.touched.mobile_banner && formik.errors.mobile_banner
                      ? "error"
                      : ""
                  }`}
                />
              </div>
            </div>
            {formik.touched.mobile_banner && formik.errors.mobile_banner && (
              <div className="management-form-error">
                {formik.errors.mobile_banner}
              </div>
            )}
          </div>

          <div className="management-form-group">
            <label className="management-form-label">
              Category <span className="required-indicator">*</span>
            </label>
            <select
              name="category"
              value={formik.values.category}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className={`management-form-input custom-select ${
                formik.touched.category && formik.errors.category ? "error" : ""
              }`}
              disabled={categoriesLoading}
            >
              <option value="">Select Category</option>
              {categoriesData?.data?.map((category) => (
                <option key={category.uid} value={category.uid}>
                  {category.name}
                </option>
              ))}
            </select>
            {formik.touched.category && formik.errors.category && (
              <div className="management-form-error">
                {formik.errors.category}
              </div>
            )}
          </div>

          <div className="management-form-group">
            <label className="management-form-label">
              Status <span className="required-indicator">*</span>
            </label>
            <div className="commonWrapper commonSwitchWrapper no-border mt-2">
              <Form.Check
                type="switch"
                name="status"
                label={
                  formik.values.status === "active" ? "Active" : "Inactive"
                }
                checked={formik.values.status === "active"}
                onChange={(e) => {
                  formik.setFieldValue(
                    "status",
                    e.target.checked ? "active" : "inactive"
                  );
                }}
              />
            </div>
            {formik.touched.status && formik.errors.status && (
              <div className="management-form-error">
                {formik.errors.status}
              </div>
            )}
          </div>
        </div>
      </form>
    </div>
  );
};

export default UpdateCourse;
